(function ($) {
  $.fn.wsAccountMenu = function (options) {
    if (typeof options != 'undefined' && options.constructor === String) {
      switch (options) {
        case 'resize':
          return this.each(function () {
            this.resizeMenu();
          });
        default:
          throw 'Option does not exist: ' + options;
      }
    }

    return this.each(function () {
      var opt = $.extend({
        delay: 100,
        speed: 10,
      }, options);

      // Elements
      let menuElement;
      let openButtonElement;

      // Variables
      //let hover = false;

      //let moveToX = 0;

      let bindEvents = function () {
        openButtonElement.click(open);

        bindNavDesktopBottomEvents();
      }

      let bindNavDesktopBottomEvents = function () {
      }


      // Resize.
      let resizeMenu = this.resizeMenu = function () {
        //menuElement.css('min-height', $(document).height() - menuElement.offset().top + 'px');
      }

      let open = this.open = function () {
        //$('body').height(menuElement.height() + menuElement.offset().top).css('overflow', 'hidden');
        //$('html').css('overflow', 'auto');
        menuElement.toggleClass('open');
      };


      let initialize = function (menuElementParameter) {
        menuElement = $(menuElementParameter);

        if (menuElement.data('ws-account-menu')) {
          console.warn('Trying to reinitialize the menu for element. Skipping.', menuElement);
          return;
        }
        menuElement.data('ws-account-menu', this);


        // Find elements and set to variable.
        openButtonElement = $(opt.openButton);

        bindEvents();

        resizeMenu();
      };

      initialize(this);

      $(window).load(function () {
        resizeMenu();
      });
      $(window).resize(function () {
        resizeMenu();
      });
    });
  };
})(jQuery);
